import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, inject, onMounted, onUnmounted, ref, watch } from "vue";
  import { useToast } from "primevue/usetoast";
  import { IAlertEventData } from "@/models";
  import { Channel } from "laravel-echo";
  import { useAuctionStore } from "@/stores/AuctionStore";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LiveAlertNotification',
  setup(__props) {

  const toast = useToast();
  const emitter = inject("emitter");
  const channel = ref<Channel | null>(null);
  const auctionStore = useAuctionStore();
  const userId = computed(() => auctionStore.user?.id);

  watch(userId, (nv) => {
    if (nv) {
      onLoad();
    }
  });

  const getLocalStorageKey = (userId: number, auctionId: number) => {
    return `oldlouis-alert-for-${userId}-auction-${auctionId}`;
  };

  const sendBrowserNotification = (data: IAlertEventData) => {
    const notification = new Notification(data.data.notificationTitle, {
      requireInteraction: true,
      body: data.data.content,
      data: {
        liveLink: data.data.liveLink
      },
      tag: getLocalStorageKey(data.userId, data.auctionId),
      renotify: true
    });
    localStorage.setItem(getLocalStorageKey(data.userId, data.auctionId), Date.now().toString());
    notification.onclick = (e) => {
      if (e.currentTarget?.data?.liveLink) {
        window.open(e.currentTarget.data.liveLink, "_blank");
      }
    };
  };

  const checkAndSendNotification = (data: IAlertEventData) => {
    const notificationKey = getLocalStorageKey(data.userId, data.auctionId);
    const now = Date.now();
    const expiration = 5 * 1000;

    const storageData = localStorage.getItem(notificationKey);

    const lastSent = storageData ? parseInt(storageData) : 0;
    if (!lastSent || now - lastSent > expiration) {
      sendBrowserNotification(data);
    }
  };

  const onLoad = () => {
    const requestPermission = () => {
      Notification.requestPermission();
      window.removeEventListener("click", requestPermission);
    };
    if (Notification.permission === "default") {
      window.addEventListener("click", requestPermission);
    }

    if (userId.value && !channel.value) {
      channel.value = window.Echo.private(`user.${userId.value}`);
      channel.value.listen(".lot_alert", (e: IAlertEventData) => {
        toast?.add({
          severity: "info",
          summary: e.data.liveTitle,
          detail: e.data.toastContent
        });

        emitter?.emit("auction:lot-alert", { content: e.data.content });
        if (Notification.permission === "granted") {
          setTimeout(() => {
            checkAndSendNotification(e);
          }, Math.floor(Math.random() * (700 - 200 + 1)) + 200);
        }
      });
    }
  };

  const onLeave = () => {
    if (userId.value && channel.value) {
      channel.value.stopListening(".lot_alert");
    }
  };

  onMounted(() => {
    onLoad();
  });

  onUnmounted(() => {
    onLeave();
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})